import { logEvent } from './logEvent'

const REVISION = 1

export const logHighlightNavigationEvent = (to: string) =>
    logEvent('navigate', { revision: REVISION, to, from: 'home_Highlights' })
